<template>
  <header class="header sec-header-wrapp" ref="header">
    <div class="container">
      <nav ref="headerInner" class="navbar">
        <div class="logo">
          <img
            loading="lazy"
            :src="this.publicPath + 'assets/images/logo.png'"
            @click="redirectToHome"
          />
        </div>
        <div
          class="hamburger"
          @click="toggleMenu"
          :class="{ active: isMenuOpen }"
        >
          <span class="bar bar1"></span>
          <span class="bar bar2"></span>
          <span class="bar bar3"></span>
        </div>
        <ul class="nav-menu" :class="{ active: isMenuOpen }">
          <li
            :class="{ 'active-link': this.$route.name === 'HomePage' }"
            class="nav-item nav-link"
            @click="redirectToHome()"
          >
            Home
          </li>
          <li
            class="nav-item"
            v-for="item in menuItems1"
            :key="item.navigation_link"
          >
            <router-link :to="item.path" class="nav-link" @click="closeMenu">
              {{ item.navigation_link }}
            </router-link>
          </li>
          <li
            :class="{
              'active-link':
                this.$route.name === 'CarrerWithUs' ||
                this.$route.name === 'AboutUs',
            }"
            class="nav-item nav-link"
            @click="toggleSubMenu()"
          >
            <span class="no-bord">Company</span>
            <font-awesome-icon
              :icon="'angle-up'"
              class="mx-1"
              :style="{
                transform: isSubMenuOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                transition: '0.3s all ease',
              }"
              aria-hidden="true"
            />
            <ul class="sub-menu scale-in-ver-top" v-if="isSubMenuOpen">
              <li class="sub-item">
                <router-link
                  :to="`/${this.lang ?? 'en'}/about-us`"
                  class="sub-link"
                  >About Us</router-link
                >
              </li>
              <li class="sub-item">
                <router-link
                  :to="`/${this.lang ?? 'en'}/careers`"
                  class="sub-link"
                  >Careers</router-link
                >
              </li>
            </ul>
          </li>
          <li
            class="nav-item"
            v-for="item in menuItems2"
            :key="item.navigation_link"
          >
            <router-link :to="item.path" class="nav-link" @click="closeMenu">
              {{ item.navigation_link }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
  <div
    v-if="isMenuOpen && windowWidth < 992"
    class="menu-overlay"
    @click="closeMenu"
  ></div>
</template>

<script>
export default {
  name: "TheHeader",
  data() {
    return {
      isMenuOpen: false,
      isSubMenuOpen: false,
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
      menuItems1: [
        {
          navigation_link: "Our Solutions",
          icon: "chalkboard-user",
          path: `/${this.lang ?? "en"}/solutions`,
        },
        {
          navigation_link: "Slots",
          path: `/${this.lang ?? "en"}/games`,
          icon: "slot-machine",
        },
      ],
      menuItems2: [
        {
          navigation_link: "Contact",
          icon: "headphones",
          path: `/${this.lang ?? "en"}/contact`,
        },
      ],
      lang: localStorage.getItem("language") ?? "en",
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 992;
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.setNormalBackground();
      if (
        window.scrollY === 0 &&
        this.isMenuOpen == false &&
        (this.$route.name === "HomePage" || this.$route.name === "AboutUs")
      ) {
        this.setTransparentBackground();
      }
    },
    closeMenu() {
      this.isSubMenuOpen = false;
      this.isMenuOpen = false;
    },
    redirectToHome() {
      this.closeMenu();
      this.$router.push({
        path: `/${this.lang}/`,
      });
    },
    toggleSubMenu() {
      this.isSubMenuOpen = !this.isSubMenuOpen;
      if (
        this.isSubMenuOpen == true &&
        (this.$route.name === "HomePage" || this.$route.name === "AboutUs") &&
        window.scrollY === 0
      ) {
        this.setNormalBackground();
      } else if (
        this.isSubMenuOpen == false &&
        (this.$route.name === "HomePage" || this.$route.name === "AboutUs") &&
        window.scrollY === 0 &&
        this.windowWidth > 992
      ) {
        this.setTransparentBackground();
      }
    },
    setTransparentBackground() {
      if (this.$refs.header && this.$refs.headerInner) {
        this.$refs.header.style.background =
          "linear-gradient(0deg, transparent, rgba(0, 0, 0, 0.8))";
        this.$refs.headerInner.style.scale = "0.95";
      }
    },
    setNormalBackground() {
      if (this.$refs.header && this.$refs.headerInner) {
        this.$refs.header.style.background = "rgb(22 33 52)";
        this.$refs.headerInner.style.scale = "1";
      }
    },
    handleScroll() {
      if (
        (this.$route.name === "HomePage" || this.$route.name === "AboutUs") &&
        window.scrollY === 0 &&
        this.isMenuOpen == false &&
        this.isSubMenuOpen == false
      ) {
        this.setTransparentBackground();
      } else {
        this.setNormalBackground();
      }
    },
    handleClickOutside(event) {
      if (
        this.$refs.header &&
        !this.$refs.header.contains(event.target) &&
        this.isSubMenuOpen
      ) {
        this.isSubMenuOpen = false;
        this.handleScroll();
      }
    },
    resizeHandler() {
      this.windowWidth = window.innerWidth;
    },
  },
  created() {
    let lang = localStorage.getItem("language") ?? "en";
    this.lang = lang;
  },
  mounted() {
    window.addEventListener("DOMContentLoaded", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  watch: {
    $route() {
      if (
        (this.isSubMenuOpen && this.isMenuOpen) ||
        this.isSubMenuOpen ||
        this.isMenuOpen
      ) {
        this.closeMenu();
        this.toggleSubMenu();
      }
      this.handleScroll();
    },
  },
};
</script>

<style scoped>
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 300;
}
</style>
